import React, { useEffect } from 'react'
import s from './ScoreList.module.scss'
import cx from 'classnames'
import { setState } from 'store/game'
import store from 'store'

import Present from 'assets/images/2024-ui/present-leaderboard.png'
import Firebase from 'scripts/util/Firebase'
import { useSelector } from 'react-redux'


ScoreList.defaultProps = {

};

export default function ScoreList({ className, rank }) {
  const { leaderboard } = useSelector((state) => state.game)
  const { connected } = useSelector((state) => state.socket)

  useEffect(() => {
    async function fetchLeaderboard() {
      const myLeaderboard = await Firebase.getLeaderboard()
      store.dispatch(setState({ leaderboard: myLeaderboard } ))
    }
    if (connected) {
      fetchLeaderboard()
    }
  }, [connected])

  return (
    <div className={cx(s.ScoreList, className)}>
      {leaderboard && leaderboard.map((entry, i) => (
        <div className={cx(s.score, { [s.active]: i === 0, [s.rank]: i === rank })} key={`score-${i}`}>
          <p className={s.textRank}>{i+1}</p>
          <p className={s.initials}>{entry.initials}</p>
          <div className={s.scoreWrapper}>
            <img className={s.present} src={Present} alt="" />
            <p>{entry?.score ? entry.score.toLocaleString() : ''}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
